module.exports = __webpack_public_path__ + "img/kachel_COLOSTRUMKAPSELN.6efc474e.png";